import { requiredValidatorShortMessage } from "../../../utils/validators";

import { MAX_DECIMAL } from "../../common/Configurations/DecimalConfiguration";

export const CLIENT_BROKER_VALIDATION_RULES = {
  broker: {
    array: {
      brokerId: requiredValidatorShortMessage,
      compensationType: requiredValidatorShortMessage,
      calculationType: requiredValidatorShortMessage,
      cashAdvance: {
        isRequiredTrimIfFieldHasValue: {
          value: {
            field: "compensationType",
            expectedValues: ["YEARLY"],
            customMessageKey: "validation.isRequiredTrimShort",
          },
        },
        valueBetween: {
          value: {
            minimum: 0,
            maximum: 100,
          },
        },
        float: {
          value: {
            decimals: MAX_DECIMAL,
          },
        },
      },
      brokerPart: {
        lowerEqualThanIfFieldHasValue: {
          value: {
            otherField: "calculationType",
            otherFieldValue: "PERCENTAGE",
            limitToApply: 100,
            customMessageKey: "validation.cannotExceed100",
          },
        },
        isRequired: {
          value: true,
        },
        float: {
          value: {
            decimals: MAX_DECIMAL,
          },
        },
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/clientBrokerValidationRules.js